import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProductCard from "./ProductCard";

export default function ProductCarousel({ title, subtitle, products = [], link, sectionKey }) {
  if (!products.length) return null;
  return (
    <section className="py-16 sm:py-24" data-section={sectionKey}>
      <div className="tq-container">
        <div className="flex items-end justify-between mb-8 gap-4">
          <div>
            <p className="tq-overline mb-2">TARISHQ Selection</p>
            <h2 className="font-serif text-3xl sm:text-4xl text-[#111111]">{title}</h2>
            {subtitle && <p className="text-sm text-[#666666] mt-2">{subtitle}</p>}
          </div>
          {link && (
            <Link to={link} data-testid={`view-all-${link.replace(/\//g, "-")}`}
              className="hidden sm:inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] border-b border-[#111111] pb-1 hover:text-[#A8821B] hover:border-[#A8821B] transition-colors shrink-0">
              View All <ArrowRight size={14} />
            </Link>
          )}
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6" data-anim-grid>
          {products.slice(0, 8).map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
        {link && (
          <div className="mt-8 text-center sm:hidden">
            <Link to={link} className="tq-btn-outline">View All</Link>
          </div>
        )}
      </div>
    </section>
  );
}
